import axios from 'axios';
import { REQUEST_TIMEOUT } from '../constants/general';
import {
  generateXB3TraceID,
  getChannelID,
  getHost,
  isSsr,
  getTmxId,
} from '../utils/general';
import { getAuthorizationToken } from '../utils/user';

// NOTE: Axios instances are created lazily (inside factory functions) rather
// than at module level to avoid "Cannot access 'X' before initialization" (TDZ)
// errors in production builds caused by circular ESM module dependencies.
// Rollup/Vite evaluates module-level const assignments immediately; if a
// circular dependency causes another module to reference these before this
// module finishes, a TDZ error is thrown at runtime.

const createApiBase = () =>
  axios.create({
    baseURL: getHost(),
    headers: {
      TMXProfileID: isSsr ? '' : getTmxId(),
    },
    timeout: REQUEST_TIMEOUT,
  });

const createApiB2C = () =>
  axios.create({
    baseURL: getHost(),
    headers: {
      channelId: getChannelID(),
      TMXProfileID: isSsr ? '' : getTmxId(),
      Authorization: getAuthorizationToken(),
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    timeout: REQUEST_TIMEOUT,
  });

const createApiB2B = () =>
  axios.create({
    baseURL: getHost(),
    headers: {
      channelId: getChannelID(),
      TMXProfileID: isSsr ? '' : getTmxId(),
      'X-B3-TraceId': generateXB3TraceID(),
    },
    timeout: REQUEST_TIMEOUT,
  });

// Singleton instances — created on first import (deferred from module parse time
// to module execution time), which is safe because by then all circular deps are resolved.
export const apiBase = createApiBase();
export const apiB2C = createApiB2C();
export const apiB2B = createApiB2B();
